import { render, staticRenderFns } from "./NewAiRobot.vue?vue&type=template&id=30cff8f2&"
import script from "./NewAiRobot.vue?vue&type=script&lang=js&"
export * from "./NewAiRobot.vue?vue&type=script&lang=js&"
import style0 from "./NewAiRobot.vue?vue&type=style&index=0&id=30cff8f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports